module.exports = __webpack_public_path__ + "static/media/update18.ee0df7eb.png";